import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid';

export type BreadcrumbItem = {
  name: string;
  href: string;
  current: boolean;
};

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  isLoading?: boolean;
}

export function Breadcrumbs({ items, isLoading }: BreadcrumbsProps) {
  return (
    <nav className="flex border-b border-gray-200 bg-white" aria-label="Breadcrumb">
      <ol role="list" className="flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8 py-4">
        <li className="flex">
          <div className="flex items-center">
            <Link to="/" className="text-gray-400 hover:text-gray-500">
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </li>
        {items.map((item) => (
          <li key={item.name} className="flex">
            <div className="flex items-center">
              <ChevronRightIcon
                className="h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <Link
                to={item.href}
                className={`ml-4 text-sm font-medium ${
                  item.current
                    ? 'text-indigo-600'
                    : 'text-gray-500 hover:text-gray-700'
                } ${isLoading ? 'animate-pulse' : ''}`}
                aria-current={item.current ? 'page' : undefined}
              >
                {item.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
